import SegmentUtils from 'utils/segment';
import ErrorUtils from 'utils/error-utils';
import StorageUtils from '@spothero/utils/storage';
import {StorageKeys, StorageTypes} from 'common/constants/storageKeys';

export default function trackAvailabilityErrorThrown({
    spotId,
    location,
    city = null,
    errorFetching = false,
}) {
    try {
        const properties = {
            partner_affiliate:
                StorageUtils.get(
                    StorageKeys.PARTNER_AFFILIATE,
                    StorageTypes.SESSION
                ) || null,
            facility_id: parseInt(spotId, 10),
            city,
            error_fetching: errorFetching,
            location,
        };

        SegmentUtils.track({
            event: 'Availability Error Thrown',
            properties,
            additionalOptions: {
                context: {
                    protocols: {
                        event_version: 1,
                    },
                },
            },
        });
    } catch (error) {
        ErrorUtils.sendSentryMessage({
            error,
            customErrorMessage:
                'Segment Event Failed - trackAvailabilityErrorThrown',
        });
    }
}
